/**
 * TooltipRowList — the shared `label : value` stack rendering used by every
 * step/row tooltip bubble in the drawer (WorkflowStepTooltipBubble's phase
 * tooltip, DetailedRunLog's chronology-row tooltip). Extracted so the two
 * stay visually identical without duplicating the JSX — only the `rows`
 * source differs (buildTooltipRows vs buildChronologyTooltipRows).
 *
 * Import alias in ora:     ~/common/workflows/components/TooltipRowList
 * Import alias in add-in:  @product-app/common/workflows/components/TooltipRowList
 */

import type { StepTooltipRow } from "../stepTooltipParts";

export interface TooltipRowListProps {
  rows: StepTooltipRow[];
}

export function TooltipRowList({ rows }: TooltipRowListProps) {
  if (rows.length === 0) return null;
  return (
    <div className="flex flex-col gap-0.5 text-2xs">
      {rows.map((r) => (
        <div key={r.label} className="flex gap-2">
          <span className="font-semibold text-primary-gray-light-700 min-w-[5.5rem]">
            {r.label}
          </span>
          <span className="text-primary-gray-light-900 break-words">
            {r.value}
          </span>
        </div>
      ))}
    </div>
  );
}

export default TooltipRowList;
